module.exports = __webpack_public_path__ + "img/Lot9.5dfbcd54.jpg";